/// <amd-module name="VC/Common/GitRepositoryService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { GitRepository } from "./Contracts/Git";
import { IGitRestClient } from "./RestClient/Git";

/**
 * Service for working with git repositories
 */
export interface IDeprecatedGitRepositoryService extends IVssService {

    /**
     * Get all the git repositories in the collection or project
     * 
     * @param projectId If specified, get the repositories only in the specified project
     */
    getAllRepositories(projectId?: string): Promise<GitRepository[]>;

    /**
     * Get a git repository for a given repository id
     * 
     * @param repositoryId The name or ID of the repository
     * @param projectId If specified, get the repositories only in the specified project
     */
    getRepositoryById(repositoryId: string, projectId?: string): Promise<GitRepository>;
}

class GitRepositoryService extends VssService implements IDeprecatedGitRepositoryService {
    private repositoriesByProject: { [project: string]: Promise<GitRepository[]>} = {};

    public getAllRepositories(projectId?: string): Promise<GitRepository[]> {
        let repositories = this.repositoriesByProject[projectId || ""];
        if (!repositories) {
            const gitClient = this.pageContext.getRestClient<IGitRestClient>("IGitRestClient");
            repositories = gitClient.getRepositories(projectId);
            this.repositoriesByProject[projectId || ""] = repositories;
        }
        return repositories;
    }
    
    public getRepositoryById(repositoryId: string, projectId?: string): Promise<GitRepository> {
        const gitClient = this.pageContext.getRestClient<IGitRestClient>("IGitRestClient");
        const repository = gitClient.getRepository(repositoryId, projectId);
        return repository;
    }
}

Services.add("IDeprecatedGitRepositoryService", { serviceFactory: GitRepositoryService });
